import { gql } from '@apollo/client'
import { BRAND_PACKAGING_FRAGMENT } from './BrandPackagingFragment'
import { PICOS_COMPLIANCE_CRITERIA_FRAGMENT } from './PicOSComplianceCriteriaFragment'

export const PICOS_PRIORITY_FRAGMENT = gql`
  fragment PicOSPriority on PicOSPriority {
    name
    id
    priority
    isActive
    verifier {
      email
    }
    storeGroup {
      id
      name
    }
    externalId
    created
    startDate
    endDate
    description
    mandateType
    displayElements
    executionTarget
    displayTypes {
      id
      name
    }
    displayLocation {
      id
      name
    }
    otherNotes
    posElementRequired
    otherBrandsAllowed
    otherPackagingAllowed
    otherProductsAllowed
    otherDisplayTypesAllowed
    otherDisplayLocationsAllowed
    isMarketStreetChallenge
    poi {
      id
      name
    }
    activeDaysRemaining
    brandPackagings {
      ...BrandPackaging
    }
    products {
      name
      upcA
      brand {
        id
        name
      }
      packaging {
        id
        quantity
        size
        unit
      }
    }
    storeChain {
      id
      name
    }
    image {
      url
      id
      bucketFileName
    }
    pricingInfo
    cost
    isMarketStreetChallenge
    complianceCriteria {
      ...PicOSProductComplianceCriteria
    }
    criteriaUpcs
  }
  ${BRAND_PACKAGING_FRAGMENT}
  ${PICOS_COMPLIANCE_CRITERIA_FRAGMENT}
`
